/** @jsxRuntime classic */
/** @jsx jsx */
import React, { Component } from "react";
import "./Editor.css";
import { SketchPicker } from "react-color";
import { CirclePicker } from "react-color";
import { jsx, css } from "@emotion/core";
import { Link } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import { connect } from "react-redux";
import { updateStore } from "../../reducers/store";

import { ReactComponent as Square } from "../../icons/square-bold.svg";
import { ReactComponent as Plus } from "../../icons/plus-circle-bold.svg";
// import { ReactComponent as Rectangles } from "../../icons/rectangles-two-bold.svg";
import { ReactComponent as Drop } from "../../icons/drop-bold.svg";
import { ReactComponent as Bold } from "../../icons/text-bold.svg";
import { ReactComponent as Close } from "../../icons/x-bold.svg";
import { ReactComponent as Sort } from "../../icons/sort-ascending-bold.svg";
import { ReactComponent as Stack } from "../../icons/stack-bold.svg";
// import { ReactComponent as ArrowDown } from "../../icons/arrow-down-bold.svg";
import { ReactComponent as Monitor } from "../../icons/monitor.svg";
import { ReactComponent as Device } from "../../icons/device-mobile.svg";
// import { ReactComponent as Less } from "../../icons/magnifying-glass-minus-bold.svg";
// import { ReactComponent as More } from "../../icons/magnifying-glass-plus-bold.svg";
import { ReactComponent as Undo } from "../../icons/arrow-bend-up-left-bold.svg";
import { ReactComponent as Redo } from "../../icons/arrow-bend-up-right-bold.svg";

import SortableComponent from "./Sort";

// import ModuleSlider from "../preview/HomeModules/ModuleSlider";
import {
  primary_light,
  primary_s15_l20,
  primary_s98_l83,
} from "../../shared/lib/colors";

import BigBanner from "../preview/BigBanner/BigBanner";
import AdviceBox from "../preview/AdviceBox/AdviceBox";
import TopBanners from "../preview/TopBanners/TopBanners";
import ItemSlider from "../../shared/ItemSlider/ItemSlider";
import ProductThumbnail from "../../shared/ProductThumbnail/ProductThumbnail";
import TagDiscounts from "../preview/TagDiscounts/TagDiscounts";
import ModuleBlogNewsletter from "../preview/HomeModules/ModuleBlogNewsletter";
// import ModuleTimeLimitedDiscount from "../preview/HomeModules/ModuleTimeLimitedDiscount";
import ModuleBannerCarousel from "../preview/HomeModules/ModuleBannerCarousel";
import ModuleServices from "../preview/HomeModules/ModuleServices";
import Button from "../../shared/Button/Button";
import Assistenza from "../../shared/Icons/Assistenza";
import PuntiRitiro from "../../shared/Icons/PuntiRitiro";
import Spedizione from "../../shared/Icons/Spedizione";
import Pagamenti from "../../shared/Icons/Pagamenti";
import TextField from "../../shared/FormFields/TextField";
// import TextFieldWithLabel from "../../shared/FormFields/TextFieldWithLabel";
import CheckboxContainer from "../../shared/FormFields/CheckboxContainer";

import Preview from "../preview/Preview";

import { storeMok } from "../../moked/store";
import categoryTags from "../../moked/tags.json";

const buttons = [
  {
    id: 1,
    icon: <Square />,
    content: "background",
    active: true,
    title: "Sfondo",
  },
  {
    id: 2,
    icon: <Plus />,
    options: [
      {
        label: "Menu Categorie",
        content: "menu_categorie",
        title: "Scegli la sezione",
      },
      {
        label: "Banner Header",
        content: "banner_header",
        title: "Scegli la sezione",
      },
      {
        label: "Slider",
        content: "slider",
        title: "Scegli la sezione",
      },
      {
        label: "Thumbnail Prodotti",
        content: "item_slider",
        title: "Scegli la sezione",
      },
      {
        label: "Banner Promo",
        content: "tags_discounts",
        title: "Scegli la sezione",
      },
      {
        label: "Blog + Newsletter",
        content: "blog_newsletter",
        title: "Scegli la sezione",
      },
      {
        label: "Countdown",
        content: "countdown",
        title: "Scegli la sezione",
      },
      {
        label: "Banner Carousel",
        content: "banner_carousel",
        title: "Scegli la sezione",
      },
      {
        label: "Servizi",
        content: "services",
        title: "Scegli la sezione",
      },
    ],
    // content: "menu_categorie",
    active: false,
  },
  // {
  //   id: 3,
  //   icon: <Rectangles />,
  //   options: [
  //     {
  //       label: "Pulsanti",
  //       content: "buttons",
  //     },
  //     {
  //       label: "Input",
  //       content: "input",
  //     },
  //     {
  //       label: "Checkbox",
  //       content: "checkbox",
  //     },
  //   ],
  //   content: "element",
  //   active: false,
  // },
  {
    id: 4,
    icon: <Drop />,
    content: "palette",
    active: false,
    title: "Palette colori",
  },
  {
    id: 5,
    icon: <Bold />,
    content: "font",
    active: false,
    title: "Scegli il font",
  },
  {
    id: 6,
    icon: <Sort />,
    content: "sort",
    active: false,
    title: "Ordina le sezioni",
  },
];

class Editor extends Component {
  constructor() {
    super();
    this.state = {
      title: null,
      active: 1,
      options: null,
      content: "background",
      background: "#fff",
      background2: "#fff",
      displayColorPicker: false,
      displayColorPicker2: false,
      backgroundColor: "#f3f4f8",
      backgroundColor2: "#f3f4f8",
      window: true,
      undos: [],
      redos: [],
      isEditorShow: true,
    };
  }

  componentDidMount() {
    this.setState({ options: buttons[0].options, title: buttons[0].title });
  }

  componentDidUpdate(oldProps, oldState) {
    if (
      oldState.background !== this.state.background ||
      oldState.brandColor !== this.state.brandColor ||
      oldState.secondaryColor !== this.state.secondaryColor ||
      oldState.font !== this.state.font ||
      oldState.menu !== this.state.menu ||
      oldState.slider !== this.state.slider ||
      oldState.sliderTagsSide !== this.state.sliderTagsSide ||
      oldState.bannerHeader !== this.state.bannerHeader ||
      oldState.bannerPromo !== this.state.bannerPromo ||
      oldState.thumbnail !== this.state.thumbnail ||
      oldState.services !== this.state.services ||
      oldState.countdown !== this.state.countdown ||
      oldState.blogNewsletter !== this.state.blogNewsletter ||
      oldState.bannerCarousel !== this.state.bannerCarousel ||
      oldState.position1 !== this.state.position1 ||
      oldState.position2 !== this.state.position2 ||
      oldState.position3 !== this.state.position3 ||
      oldState.position4 !== this.state.position4 ||
      oldState.position5 !== this.state.position5 ||
      oldState.position6 !== this.state.position6 ||
      oldState.position7 !== this.state.position7 ||
      oldState.position8 !== this.state.position8 ||
      oldState.position9 !== this.state.position9
    ) {
      this.handleUpdate();
    }
  }

  change = (element) => {
    const active = buttons.find((button) => button.id === element.id);
    this.setState({
      options: element.options,
      active: element.id,
      title: active.title || active.options[0].title,
      content: active.content || active.options[0].content,
      window: true,
    });
  };

  handleChangeComplete = (color) => {
    this.setState({ background: color.hex, backgroundColor: color.hex });
  };

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleClick2 = () => {
    this.setState({ displayColorPicker2: !this.state.displayColorPicker2 });
  };

  handleToggle = () => {
    this.setState({ isEditorShow: !this.state.isEditorShow });
    // console.log(this.state.isEditorShow);
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false });
  };

  handleClose2 = () => {
    this.setState({ displayColorPicker2: false });
  };

  handleChange = (color) => {
    this.setState({ color: color.rgb });
  };

  handleSelectBrandColors = (color) => {
    this.setState({
      brandColor: color,
      primaryColor: color,
      secondaryColor: `${color}66`,
    });
  };

  _handleSelectVariant = (target, variant) => {
    this.setState({ [target]: variant });
  };

  _handleChangeOrder = (order) => {
    const obj = order.reduce((acc, curr, i) => {
      acc[`position${i + 1}`] = curr;
      return acc;
    }, {});

    // console.log(order, obj);

    this.setState({ ...obj });
  };

  renderContent(contentId) {
    switch (contentId) {
      case "background":
        return <ColorPicker {...this} {...this.state} />;
      case "palette":
        return (
          <Palette
            {...this}
            {...this.state}
            selectBrandColors={this.handleSelectBrandColors}
          />
        );
      case "font":
        return (
          <Font
            variant={this.state.font || this.props.store.font}
            handleSelectVariant={this._handleSelectVariant}
            primaryColor={this.state.primaryColor}
          />
        );
      case "sort":
        return (
          <SortableComponent
            items={[
              this.props.store.position1,
              this.props.store.position2,
              this.props.store.position3,
              this.props.store.position4,
              this.props.store.position5,
              this.props.store.position6,
              this.props.store.position7,
              this.props.store.position8,
            ]}
            handleChangeOrder={this._handleChangeOrder}
          />
        );
      case "slider":
        return (
          <SelectSlider
            variant={this.state.slider || this.props.store.slider}
            handleSelectVariant={this._handleSelectVariant}
            primaryColor={this.state.primaryColor}
          />
        );
      case "banner_header":
        return (
          <SelectBannerHeader
            variant={this.state.bannerHeader || this.props.store.bannerHeader}
            handleSelectVariant={this._handleSelectVariant}
            primaryColor={this.state.primaryColor}
          />
        );
      case "tags_discounts":
        return (
          <TagsDiscount
            variant={this.state.bannerPromo || this.props.store.bannerPromo}
            handleSelectVariant={this._handleSelectVariant}
            primaryColor={this.state.primaryColor}
          />
        );
      case "blog_newsletter":
        return (
          <BlogNewsletter
            variant={
              this.state.blogNewsletter || this.props.store.blogNewsletter
            }
            handleSelectVariant={this._handleSelectVariant}
            primaryColor={this.state.primaryColor}
          />
        );
      case "countdown":
        return (
          <Countdown
            variant={this.state.countdown || this.props.store.countdown}
            handleSelectVariant={this._handleSelectVariant}
            primaryColor={this.state.primaryColor}
          />
        );
      case "banner_carousel":
        return (
          <BannerCarousel
            variant={
              this.state.bannerCarousel || this.props.store.bannerCarousel
            }
            handleSelectVariant={this._handleSelectVariant}
            primaryColor={this.state.primaryColor}
          />
        );
      case "services":
        return (
          <Services
            variant={this.state.services || this.props.store.services}
            handleSelectVariant={this._handleSelectVariant}
            primaryColor={this.state.primaryColor}
          />
        );
      case "buttons":
        return (
          <SelectButton
            handleSelectVariant={this._handleSelectVariant}
            primaryColor={this.state.primaryColor}
          />
        );
      case "input":
        return (
          <SelectInput
            handleSelectVariant={this._handleSelectVariant}
            primaryColor={this.state.primaryColor}
          />
        );
      case "checkbox":
        return (
          <SelectCheckbox
            handleSelectVariant={this._handleSelectVariant}
            primaryColor={this.state.primaryColor}
          />
        );
      case "item_slider":
        return (
          <SelectItemSlider
            variant={this.state.thumbnail || this.props.store.thumbnail}
            handleSelectVariant={this._handleSelectVariant}
            primaryColor={this.state.primaryColor}
          />
        );
      case "menu_categorie":
        return (
          <SelectMenuCategorie
            variant={this.state.menu || this.props.store.menu}
            handleSelectVariant={this._handleSelectVariant}
            primaryColor={this.state.primaryColor}
          />
        );
      default:
        return contentId;
    }
  }

  handleUpdate = () => {
    // gestisco la coda di azioni
    this._handleStack("new_action");

    // aggiorno
    const { storeId } = this.props.match.params;
    const obj = {
      background: this.state.backgroundColor,
      brandColor: this.state.brandColor,
      secondaryColor: this.state.secondaryColor,
      font: this.state.font,
      menu: this.state.menu,
      slider: this.state.slider,
      sliderTagsSide: this.state.sliderTagsSide,
      bannerHeader: this.state.bannerHeader,
      bannerPromo: this.state.bannerPromo,
      thumbnail: this.state.thumbnail,
      services: this.state.services,
      countdown: this.state.countdown,
      blogNewsletter: this.state.blogNewsletter,
      bannerCarousel: this.state.bannerCarousel,
      position1: this.state.position1,
      position2: this.state.position2,
      position3: this.state.position3,
      position4: this.state.position4,
      position5: this.state.position5,
      position6: this.state.position6,
      position7: this.state.position7,
      position8: this.state.position8,
      position9: this.state.position9,
    };
    this.props.updateStore(storeId, obj);
  };

  _handleStack = (type) => {
    switch (type) {
      case "new_action": {
        this._handleAddUndo();
        this._resetRedos();
        break;
      }
      case "undo": {
        this._handleAddRedo();
        this._handleStackAction("undo");
        break;
      }
      case "redo": {
        this._handleAddUndo();
        this._handleStackAction("redo");
        break;
      }
      default:
        break;
    }
  };

  _handleStackAction = (type) => {
    switch (type) {
      case "undo": {
        // eseguo ultimo undo
        const { storeId } = this.props.match.params;
        const obj = this.state.undos[this.state.undos.length - 1];
        this.props.updateStore(storeId, obj);
        // rimuovo ultimo undo
        const newUndos = [...this.state.undos];
        newUndos.pop();
        this.setState({
          undos: newUndos,
        });
        break;
      }
      case "redo": {
        // eseguo ultimo undo
        const { storeId } = this.props.match.params;
        const obj = this.state.redos[this.state.redos.length - 1];
        this.props.updateStore(storeId, obj);
        // rimuovo ultimo undo
        const newRedos = [...this.state.redos];
        newRedos.pop();
        this.setState({
          redos: newRedos,
        });
        break;
      }
      default:
        break;
    }
  };

  _resetRedos = () => {
    this.setState({
      redos: [],
    });
  };

  _handleAddUndo = () => {
    const prevStatus = {
      background: this.props.store.background,
      brandColor: this.props.store.brandColor,
      secondaryColor: this.props.store.secondaryColor,
      font: this.props.store.font,
      menu: this.props.store.menu,
      slider: this.props.store.slider,
      sliderTagsSide: this.props.store.sliderTagsSide,
      bannerHeader: this.props.store.bannerHeader,
      bannerPromo: this.props.store.bannerPromo,
      thumbnail: this.props.store.thumbnail,
      services: this.props.store.services,
      countdown: this.props.store.countdown,
      blogNewsletter: this.props.store.blogNewsletter,
      bannerCarousel: this.props.store.bannerCarousel,
      position1: this.props.store.position1,
      position2: this.props.store.position2,
      position3: this.props.store.position3,
      position4: this.props.store.position4,
      position5: this.props.store.position5,
      position6: this.props.store.position6,
      position7: this.props.store.position7,
      position8: this.props.store.position8,
      position9: this.props.store.position9,
    };
    this.setState({
      undos: [...this.state.undos, prevStatus],
    });
  };

  _handleAddRedo = () => {
    const prevStatus = {
      background: this.props.store.background,
      brandColor: this.props.store.brandColor,
      secondaryColor: this.props.store.secondaryColor,
      font: this.props.store.font,
      menu: this.props.store.menu,
      slider: this.props.store.slider,
      sliderTagsSide: this.props.store.sliderTagsSide,
      bannerHeader: this.props.store.bannerHeader,
      bannerPromo: this.props.store.bannerPromo,
      thumbnail: this.props.store.thumbnail,
      services: this.props.store.services,
      countdown: this.props.store.countdown,
      blogNewsletter: this.props.store.blogNewsletter,
      bannerCarousel: this.props.store.bannerCarousel,
      position1: this.props.store.position1,
      position2: this.props.store.position2,
      position3: this.props.store.position3,
      position4: this.props.store.position4,
      position5: this.props.store.position5,
      position6: this.props.store.position6,
      position7: this.props.store.position7,
      position8: this.props.store.position8,
      position9: this.props.store.position9,
    };
    this.setState({
      redos: [...this.state.redos, prevStatus],
    });
  };

  _openMobile = () => {
    window.open(
      `/preview/${this.props.match.params.storeId}`,
      "targetWindow",
      "toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=375,height=812"
    );
  };

  render() {
    // console.log(this.props);
    return (
      <div>
        {/* <Navbar /> */}
        <div
          className="bar-tools"
          style={{
            position: "fixed",
            top: 88,
            zIndex: 1001,
            backgroundColor: "white",
            width: "100%",
          }}
        >
          <div className="bar-tools-left">
            <div className="block-tools">
              <div className="tool">
                <Stack onClick={this.handleToggle} />
              </div>
            </div>
            {/* <div className="block-tools">
              <p>
                Pagina <span>Home</span>
              </p>
            </div> */}
            <div className="block-tools">
              <div className="tool">
                <Monitor />
              </div>
              <div className="tool">
                <div
                  // href={`/preview/${this.props.match.params.storeId}`}
                  // target="_blank"
                  onClick={this._openMobile}
                >
                  <Device style={{ marginTop: 6 }} />
                </div>
              </div>
            </div>
          </div>
          <div className="bar-tools-right">
            {/* <div className="block-tools">
              <div className="tool">
                <Less />
              </div>
              <div className="tool">
                <More />
              </div>
            </div> */}
            <div className="block-tools">
              <div
                style={{ opacity: this.state.undos.length > 0 ? 1 : 0.5 }}
                onClick={() => {
                  if (this.state.undos.length > 0) {
                    this._handleStack("undo");
                  }
                }}
                className="tool hoverOpacity"
              >
                <Undo /> <span>Annulla</span>
              </div>
              <div
                style={{ opacity: this.state.redos.length > 0 ? 1 : 0.5 }}
                onClick={() => {
                  if (this.state.redos.length > 0) {
                    this._handleStack("redo");
                  }
                }}
                className="tool hoverOpacity"
              >
                <Redo /> <span>Ripeti</span>
              </div>
            </div>
          </div>
        </div>
        <div
          id="editor-container"
          style={{ backgroundColor: this.state.backgroundColor }}
        >
          {/* {this.state.isEditorShow && ( */}
          <div
            className="tools-overlay"
            style={{
              zIndex: 1001,
              left: this.state.isEditorShow ? 24 : -2000,
              transition: "all 0.8s ease-in-out",
            }}
          >
            <ul className="circle-tools">
              {buttons.map((button) => (
                <li
                  key={button.id}
                  className={this.state.active === button.id ? "active" : null}
                  onClick={() => this.change(button)}
                >
                  {button.icon}
                </li>
              ))}
            </ul>
            {this.state.window ? (
              <div className="window-tool">
                {this.state.options && (
                  <div className="window-left">
                    <ul>
                      {this.state.options.map((element) => (
                        <li
                          className="btn-select-editor"
                          onClick={() => {
                            // console.log("clicked", element.content);
                            this.setState({ content: element.content });
                          }}
                        >
                          {element.label}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                <div className="window-right">
                  <div className="window-right-header">
                    <h4>{this.state.title}</h4>
                    <Close
                      onClick={() =>
                        this.setState({
                          window: false,
                          active: "",
                        })
                      }
                    />
                  </div>
                  {this.state.content && this.renderContent(this.state.content)}
                </div>
              </div>
            ) : null}
          </div>
          {/* )} */}
          <div style={{ paddingTop: 64 }}>
            <Preview id={this.props.match.params.storeId} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    store: state.store.singleStore,
  };
};

export default connect(mapStateToProps, { updateStore })(Editor);

const ColorPicker = (props) => {
  const popover = {
    position: "absolute",
    zIndex: "10",
    right: -90,
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.6)",
  };

  const cover = {
    position: "fixed",
    top: "0px",
    right: "0px",
    bottom: "0px",
    left: "0px",
  };
  return (
    <div>
      <div className="circle-picker-container">
        <p>I colori consigliati</p>
        <CirclePicker
          width="100%"
          colors={[
            "#ffffff",
            "#f3f4f8",
            "#edf1fd",
            "#d0ffef",
            "#ffe3ef",
            "#c5f1fe",
          ]}
          color={props.background}
          onChangeComplete={props.handleChangeComplete}
        />
      </div>
      <div className="block-picker-container">
        <button className="white" onClick={props.handleClick}>
          <Drop /> <span>Scegli</span>
        </button>
        {props.displayColorPicker ? (
          <div style={popover}>
            <div style={cover} onClick={props.handleClose} />
            <SketchPicker
              color={props.background}
              onChangeComplete={props.handleChangeComplete}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

const SelectSlider = (props) => {
  return (
    <div style={{ width: "60vw", height: "60vh", overflowY: "scroll" }}>
      <WithContainer
        selected={props.variant == "1"}
        label="Slider 1"
        action={() => props.handleSelectVariant("slider", 1)}
        content={
          <ModuleSlider
            home={storeMok.home}
            tags={storeMok.tags}
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            uiVariantBannerHeader="1"
            uiVariantSlider="1"
            uiVariantSliderTagsSide="dx"
          />
        }
      />
      <WithContainer
        selected={props.variant == "2"}
        label="Slider 2"
        action={() => props.handleSelectVariant("slider", 2)}
        content={
          <ModuleSlider
            home={storeMok.home}
            tags={storeMok.tags}
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            uiVariantBannerHeader="2"
            uiVariantSlider="2"
            uiVariantSliderTagsSide="dx"
          />
        }
      />
      <WithContainer
        selected={props.variant == "3"}
        label="Slider 3"
        action={() => props.handleSelectVariant("slider", 3)}
        content={
          <ModuleSlider
            home={storeMok.home}
            tags={storeMok.tags}
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            uiVariantBannerHeader="3"
            uiVariantSlider="3"
            uiVariantSliderTagsSide="dx"
          />
        }
      />
    </div>
  );
};

const SelectBannerHeader = (props) => {
  return (
    <div style={{ width: "60vw", height: "60vh", overflowY: "scroll" }}>
      <WithContainer
        selected={props.variant == "1"}
        label="Banner Header 1"
        action={() => props.handleSelectVariant("bannerHeader", 1)}
        content={
          <TopBanners
            home={storeMok.home}
            uiVariantBannerHeader="1"
            uiVariantSliderTagsSide="1"
          />
        }
      />
      <WithContainer
        selected={props.variant == "2"}
        label="Banner Header 2"
        action={() => props.handleSelectVariant("bannerHeader", 2)}
        content={
          <TopBanners
            home={storeMok.home}
            uiVariantBannerHeader="2"
            uiVariantSliderTagsSide="2"
          />
        }
      />
      <WithContainer
        selected={props.variant == "3"}
        label="Banner Header 3"
        action={() => props.handleSelectVariant("bannerHeader", 3)}
        content={
          <TopBanners
            home={storeMok.home}
            uiVariantBannerHeader="3"
            uiVariantSliderTagsSide="3"
          />
        }
      />
    </div>
  );
};

const SelectItemSlider = (props) => {
  return (
    <div style={{ width: "70vw", height: "60vh", overflowY: "scroll" }}>
      <WithContainer
        selected={props.variant == "1"}
        label="Prodotti 1"
        action={() => props.handleSelectVariant("thumbnail", 1)}
        content={
          <ItemSlider
            loading={false}
            // title="Prodotti"
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            uiVariant="1"
          >
            {storeMok.latest.map((product) => {
              return (
                <ProductThumbnail
                  uiVariant="1"
                  key={product.id}
                  product={product}
                  primary={props.primaryColor || "rgba(51, 110, 212,0.6)"}
                  secondary={
                    props.primaryColor
                      ? `${props.primaryColor}77`
                      : "rgba(51, 110, 212,0.6)"
                  }
                  list="Latest/Bestsellers slider"
                />
              );
            })}
          </ItemSlider>
        }
      />
      <WithContainer
        selected={props.variant == "2"}
        label="Prodotti 2"
        action={() => props.handleSelectVariant("thumbnail", 2)}
        content={
          <ItemSlider
            loading={false}
            // title="Prodotti"
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            uiVariant="2"
          >
            {storeMok.latest.map((product) => {
              return (
                <ProductThumbnail
                  uiVariant="2"
                  key={product.id}
                  product={product}
                  primary={props.primaryColor || "rgba(51, 110, 212,0.6)"}
                  secondary={
                    props.primaryColor
                      ? `${props.primaryColor}77`
                      : "rgba(51, 110, 212,0.6)"
                  }
                  list="Latest/Bestsellers slider"
                />
              );
            })}
          </ItemSlider>
        }
      />
      <WithContainer
        selected={props.variant == "3"}
        label="Prodotti 3"
        action={() => props.handleSelectVariant("thumbnail", 3)}
        content={
          <ItemSlider
            loading={false}
            // title="Prodotti"
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            uiVariant="3"
          >
            {storeMok.latest.map((product) => {
              return (
                <ProductThumbnail
                  uiVariant="3"
                  key={product.id}
                  product={product}
                  primary={props.primaryColor || "rgba(51, 110, 212,0.6)"}
                  secondary={
                    props.primaryColor
                      ? `${props.primaryColor}77`
                      : "rgba(51, 110, 212,0.6)"
                  }
                  list="Latest/Bestsellers slider"
                />
              );
            })}
          </ItemSlider>
        }
      />
    </div>
  );
};

const ModuleSlider = (props) => {
  return (
    <div
      className="row"
      style={{
        flexDirection:
          props.uiVariantSliderTagsSide === "sx" ? "row-reverse" : "row",
      }}
    >
      <div className="col-lg-9">
        <BigBanner
          home={storeMok.home}
          primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
          rounded={props.uiVariantSlider === "1"}
          dotsOnRight={props.uiVariantSlider === "1"}
          uiVariantSlider={props.uiVariantSlider}
        />
      </div>
      <div className="col-lg-3">
        <AdviceBox
          tags={storeMok.tags}
          adviceTitle={storeMok.home.adviceTitle}
          primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
          uiVariantSlider={props.uiVariantSlider}
        />
      </div>
    </div>
  );
};

const TagsDiscount = (props) => {
  return (
    <div style={{ width: "65vw", height: "60vh", overflowY: "scroll" }}>
      <WithContainer
        selected={props.variant == "1"}
        label="Banner Promo 1"
        action={() => props.handleSelectVariant("bannerPromo", 1)}
        content={
          <TagDiscounts
            tags={storeMok.tagsDiscounts}
            discountsTitle={storeMok.home.discountsTitle}
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            uiVariantBannerPromo="1"
          />
        }
      />
      <WithContainer
        selected={props.variant == "2"}
        label="Banner Promo 2"
        action={() => props.handleSelectVariant("bannerPromo", 2)}
        content={
          <TagDiscounts
            tags={storeMok.tagsDiscounts}
            discountsTitle={storeMok.home.discountsTitle}
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            uiVariantBannerPromo="2"
          />
        }
      />
      <WithContainer
        selected={props.variant == "3"}
        label="Banner Promo 3"
        action={() => props.handleSelectVariant("bannerPromo", 3)}
        content={
          <TagDiscounts
            tags={storeMok.tagsDiscounts}
            discountsTitle={storeMok.home.discountsTitle}
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            uiVariantBannerPromo="3"
          />
        }
      />
    </div>
  );
};

const BlogNewsletter = (props) => {
  return (
    <div style={{ width: "60vw", height: "60vh", overflowY: "scroll" }}>
      <WithContainer
        selected={props.variant == "1"}
        label="Blog + Newsletter 1"
        action={() => props.handleSelectVariant("blogNewsletter", 1)}
        content={
          <ModuleBlogNewsletter
            hasBlog={true}
            home={storeMok.home}
            posts={storeMok.posts}
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            uiVariantBlogNewsletter="1"
          />
        }
      />
      <WithContainer
        selected={props.variant == "2"}
        label="Blog + Newsletter 2"
        action={() => props.handleSelectVariant("blogNewsletter", 2)}
        content={
          <ModuleBlogNewsletter
            hasBlog={true}
            home={storeMok.home}
            posts={storeMok.posts}
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            uiVariantBlogNewsletter="2"
          />
        }
      />
      <WithContainer
        selected={props.variant == "3"}
        label="Blog + Newsletter 3"
        action={() => props.handleSelectVariant("blogNewsletter", 3)}
        content={
          <ModuleBlogNewsletter
            hasBlog={true}
            home={storeMok.home}
            posts={storeMok.posts}
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            uiVariantBlogNewsletter="3"
          />
        }
      />
    </div>
  );
};

const Countdown = (props) => {
  return (
    storeMok.home.timeLimitedDiscount && (
      <div style={{ width: "65vw", height: "60vh", overflowY: "scroll" }}>
        <WithContainer
          selected={props.variant == "1"}
          label="Countdown 1"
          action={() => props.handleSelectVariant("countdown", 1)}
          content={
            <ModuleBlogNewsletter
              hasBlog={true}
              home={storeMok.home}
              posts={storeMok.posts}
              primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
              uiVariantBlogNewsletter="1"
            />
          }
        />
        <WithContainer
          selected={props.variant == "2"}
          label="Countdown 2"
          action={() => props.handleSelectVariant("countdown", 2)}
          content={
            <ModuleBlogNewsletter
              hasBlog={true}
              home={storeMok.home}
              posts={storeMok.posts}
              primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
              uiVariantBlogNewsletter="2"
            />
          }
        />
        <WithContainer
          selected={props.variant == "3"}
          label="Countdown 3"
          action={() => props.handleSelectVariant("countdown", 3)}
          content={
            <ModuleBlogNewsletter
              hasBlog={true}
              home={storeMok.home}
              posts={storeMok.posts}
              primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
              uiVariantBlogNewsletter="3"
            />
          }
        />
      </div>
    )
  );
};

const BannerCarousel = (props) => {
  const bottomSlides = [
    {
      id: 1,
      seoName: storeMok.home.slider1Slide1SeoName,
      imgUrl: storeMok.home.slider1Slide1Image,
      link: storeMok.home.slider1Slide1Link,
    },
    {
      id: 2,
      seoName: storeMok.home.slider1Slide2SeoName,
      imgUrl: storeMok.home.slider1Slide2Image,
      link: storeMok.home.slider1Slide2Link,
    },
    {
      id: 3,
      seoName: storeMok.home.slider1Slide3SeoName,
      imgUrl: storeMok.home.slider1Slide3Image,
      link: storeMok.home.slider1Slide3Link,
    },
  ];
  return (
    bottomSlides && (
      <div style={{ width: "60vw", height: "60vh", overflowY: "scroll" }}>
        <WithContainer
          selected={props.variant == "1"}
          label="Banner Carousel 1"
          action={() => props.handleSelectVariant("bannerCarousel", 1)}
          content={
            <ModuleBannerCarousel
              slides={bottomSlides}
              primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
              uiVariantBannerCarousel="1"
            />
          }
        />
        <WithContainer
          selected={props.variant == "2"}
          label="Banner Carousel 2"
          action={() => props.handleSelectVariant("bannerCarousel", 2)}
          content={
            <ModuleBannerCarousel
              slides={bottomSlides}
              primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
              uiVariantBannerCarousel="2"
            />
          }
        />
        <WithContainer
          selected={props.variant == "3"}
          label="Banner Carousel 3"
          action={() => props.handleSelectVariant("bannerCarousel", 3)}
          content={
            <ModuleBannerCarousel
              slides={bottomSlides}
              primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
              uiVariantBannerCarousel="3"
            />
          }
        />
      </div>
    )
  );
};

const Services = (props) => {
  const services = [
    {
      id: 1,
      title: "Aiuto e supporto",
      icon: <Assistenza />,
      url: "/pagine/contattaci",
    },
    {
      id: 2,
      title: "Punti di ritiro",
      icon: <PuntiRitiro />,
      url: "/pagine/condizioni-vendita",
    },
    {
      id: 3,
      title: "Consegne",
      icon: <Spedizione />,
      url: "/pagine/modalita-costi-spedizione",
    },
    {
      id: 4,
      title: "Pagamenti",
      icon: <Pagamenti />,
      url: "/pagine/pagamenti-accettati",
    },
  ];
  return (
    <div style={{ width: "65vw", height: "60vh", overflowY: "scroll" }}>
      <WithContainer
        selected={props.variant == "1"}
        label="Versione 1"
        action={() => props.handleSelectVariant("services", 1)}
        content={
          <ModuleServices
            services={services}
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            uiVariantServices="1"
          />
        }
      />
      <WithContainer
        selected={props.variant == "2"}
        label="Versione 2"
        action={() => props.handleSelectVariant("services", 2)}
        content={
          <ModuleServices
            services={services}
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            uiVariantServices="2"
          />
        }
      />
      <WithContainer
        selected={props.variant == "3"}
        label="Versione 3"
        action={() => props.handleSelectVariant("services", 3)}
        content={
          <ModuleServices
            services={services}
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            uiVariantServices="3"
          />
        }
      />
    </div>
  );
};

const SelectMenuCategorie = (props) => {
  return (
    <div
      style={{
        minWidth: 1000,
        height: "60vh",
        maxHeight: 680,
        overflowY: "scroll",
      }}
    >
      <WithContainer
        selected={props.variant == "1"}
        label="Menu Categorie 1"
        action={() => props.handleSelectVariant("menu", 1)}
        content={
          <MenuCategorie
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            secondaryColor={props.secondaryColor || "rgba(51, 110, 212, 0.5)"}
            uiVariantMenu="1"
            categoryTags={categoryTags}
          />
        }
      />
      <WithContainer
        selected={props.variant == "2"}
        label="Menu Categorie 2"
        action={() => props.handleSelectVariant("menu", 2)}
        content={
          <MenuCategorie
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            secondaryColor={props.secondaryColor || "rgba(51, 110, 212, 0.5)"}
            uiVariantMenu="2"
            categoryTags={categoryTags}
          />
        }
      />
      <WithContainer
        selected={props.variant == "3"}
        label="Menu Categorie 3"
        action={() => props.handleSelectVariant("menu", 3)}
        content={
          <MenuCategorie
            primaryColor={props.primaryColor || "rgb(51, 110, 212)"}
            secondaryColor={props.secondaryColor || "rgba(51, 110, 212, 0.5)"}
            uiVariantMenu="3"
            categoryTags={categoryTags}
          />
        }
      />
    </div>
  );
};

const MenuCategorie = (props) => {
  const { categoryTags, uiVariantMenu, primaryColor, secondaryColor } = props;
  const bottomMenuStyle = css`
    &.variant-1 {
      .desktop-menu a.link {
        margin: 0 10px;
        padding: 10px;
      }

      .desktop-menu a.link,
      .mobile-menu .user-section .open-login > a,
      .mobile-menu .user-section .welcome-user {
        color: ${primaryColor};
        font-size: 13px;
        background-color: ${primary_light(primaryColor)};
        border-radius: 12px;

        &:focus,
        &:hover,
        &.active {
          color: ${primaryColor};
          background-color: ${primary_s98_l83(secondaryColor)};
        }
      }
    }

    &.variant-2 {
      .desktop-menu a.link {
        margin: 0 10px;
        padding: 10px 9px;
      }
      .desktop-menu a.link,
      .mobile-menu .user-section .open-login > a,
      .mobile-menu .user-section .welcome-user {
        color: ${primaryColor};
        font-size: 13px;
        border-width: 1px;
        border-style: solid;
        border-color: ${primaryColor};

        &:focus,
        &:hover,
        &.active {
          color: #fff;
          background-color: ${primaryColor};
        }
      }
    }

    &.variant-3 {
      .desktop-menu a.link,
      .mobile-menu .user-section .open-login > a,
      .mobile-menu .user-section .welcome-user {
        color: ${primary_s15_l20(primaryColor)};
        font-size: 12px;
        text-transform: uppercase;

        &:focus,
        &:hover,
        &.active {
          color: ${primaryColor};
        }
      }

      .desktop-menu a.link {
        margin: 0 8px;

        &.active svg {
          transform: rotate(180deg);
          transition: all 0.3s ease-in-out;
        }

        svg {
          margin-left: 10px;
          transform: rotate(0);
          transition: all 0.3s ease-in-out;
        }
      }
    }

    .desktop-menu > a.link {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      &:first-of-type {
        margin-left: 0;
      }
      &:last-of-type {
        margin-right: 0;
      }
    }

    .mobile-menu > a.link {
      &:focus,
      &:hover {
        color: ${primaryColor};
      }
    }
  `;
  return (
    <div className={`bottom variant-${uiVariantMenu}`} css={bottomMenuStyle}>
      <div
        className={`navbar-collapse collapse show justify-between`}
        id="menu"
      >
        <div className="container">
          <div className="desktop-menu">
            {categoryTags &&
              categoryTags.map((tag) => (
                <Link key={tag.name} to="#" className={`link`}>
                  {tag.name}
                  {uiVariantMenu === "3" && <FaChevronDown />}
                </Link>
              ))}

            <Link to="#" className={`link`}>
              Farmaci
              {uiVariantMenu === "3" && <FaChevronDown />}
            </Link>
            <Link to="#" className={`link`}>
              Prodotti
              {uiVariantMenu === "3" && <FaChevronDown />}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

const SelectButton = (props) => {
  return (
    <ul style={{ padding: 30 }}>
      <h6>Versione 1</h6>
      <li
        style={{ textAlign: "center", padding: 10 }}
        onClick={() => props.handleSelectVariant("buttons", 1)}
      >
        <Button
          primary={props.primaryColor || "rgb(51, 110, 212)"}
          variant="1"
          type="button"
          className="btn btn-thick btn-login btn-primary"
          disabled
        >
          <span>Pulsante</span>
        </Button>
      </li>
      <h6>Versione 2</h6>
      <li
        style={{ textAlign: "center", padding: 10 }}
        onClick={() => props.handleSelectVariant("buttons", 2)}
      >
        <Button
          primary={props.primaryColor || "rgb(51, 110, 212)"}
          variant="2"
          type="button"
          className="btn btn-thick btn-login btn-primary"
          disabled
        >
          <span>Pulsante</span>
        </Button>
      </li>
      <h6>Versione 3</h6>
      <li
        style={{ textAlign: "center", padding: 10 }}
        onClick={() => props.handleSelectVariant("buttons", 3)}
      >
        <Button
          primary={props.primaryColor || "rgb(51, 110, 212)"}
          variant="3"
          type="button"
          className="btn btn-thick btn-login btn-primary"
          disabled
        >
          <span>Pulsante</span>
        </Button>
      </li>
    </ul>
  );
};

const SelectInput = (props) => {
  return (
    <ul
      style={{
        display: "flex",
        flexDirection: "column",
        minWidth: 500,
        background: "#f3f4ff",
        marginBottom: 0,
      }}
    >
      <li
        style={{ marginBottom: 5 }}
        onClick={() => props.handleSelectVariant("inputText", 1)}
      >
        <h6>Versione 1</h6>
        <TextField
          input="text"
          label="Cerca"
          type="text"
          // rows={5}
          meta={{
            asyncValidating: false,
            touched: false,
            error: false,
          }}
          primary={props.primaryColor || "rgb(51, 110, 212)"}
          variant="1"
        />
      </li>
      <li
        style={{ marginBottom: 5 }}
        onClick={() => props.handleSelectVariant("inputText", 2)}
      >
        <h6>Versione 2</h6>
        <TextField
          input="text"
          label="Cerca"
          type="text"
          // rows={5}
          meta={{
            asyncValidating: false,
            touched: false,
            error: false,
          }}
          primary={props.primaryColor || "rgb(51, 110, 212)"}
          variant="2"
        />
      </li>
      <li
        style={{ marginBottom: 5 }}
        onClick={() => props.handleSelectVariant("inputText", 3)}
      >
        <h6>Versione 3</h6>
        <TextField
          input="text"
          label="Cerca"
          type="text"
          // rows={5}
          meta={{
            asyncValidating: false,
            touched: false,
            error: false,
          }}
          primary={props.primaryColor || "rgb(51, 110, 212)"}
          variant="3"
        />
      </li>
    </ul>
  );
};

const SelectCheckbox = (props) => {
  return (
    <ul
      style={{
        display: "flex",
        flexDirection: "column",
        minWidth: 500,
        background: "#f3f4ff",
        marginBottom: 0,
      }}
    >
      <li
        style={{ marginBottom: 20 }}
        onClick={() => props.handleSelectVariant("inputCheckbox", 1)}
      >
        <h6>Versione 1</h6>
        <CheckboxContainer
          primary={props.primaryColor || "rgb(51, 110, 212)"}
          variant="1"
          className="privacy"
        >
          <input
            className="form-control"
            type="checkbox"
            id="privacy"
            name="privacy"
          />
          <label htmlFor="privacy">
            Accetto il trattamento dei dati sulla privacy
          </label>
        </CheckboxContainer>
      </li>
      <li
        style={{ marginBottom: 20 }}
        onClick={() => props.handleSelectVariant("inputCheckbox", 2)}
      >
        <h6>Versione 2</h6>
        <CheckboxContainer
          primary={props.primaryColor || "rgb(51, 110, 212)"}
          variant="2"
          className="privacy"
        >
          <input
            className="form-control"
            type="checkbox"
            id="privacy-2"
            name="privacy-2"
          />
          <label htmlFor="privacy-2">
            Accetto il trattamento dei dati sulla privacy
          </label>
        </CheckboxContainer>
      </li>
      <li
        style={{ marginBottom: 20 }}
        onClick={() => props.handleSelectVariant("inputCheckbox", 3)}
      >
        <h6>Versione 3</h6>
        <CheckboxContainer
          primary={props.primaryColor || "rgb(51, 110, 212)"}
          variant="3"
          className="privacy"
        >
          <input
            className="form-control"
            type="checkbox"
            id="privacy-3"
            name="privacy-3"
          />
          <label htmlFor="privacy-3">
            Accetto il trattamento dei dati sulla privacy
          </label>
        </CheckboxContainer>
      </li>
    </ul>
  );
};

const Palette = (props) => {
  const colors = ["#A300D9", "#FF8BDC", "#0099FF", "#04AE55", "#06D595"];
  const popover = {
    position: "absolute",
    zIndex: "10",
    top: 200,
    right: -90,
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.6)",
  };

  const cover = {
    position: "fixed",
    top: "0px",
    right: "0px",
    bottom: "0px",
    left: "0px",
  };
  return (
    <div className="palette-box">
      <ul className="scroll list-components">
        {colors.map((element, id) => (
          <li onClick={() => props.selectBrandColors(element)}>
            <h6>Colore {id + 1}</h6>
            <div className="palette">
              <div style={{ backgroundColor: `${element}66` }}></div>
              <div style={{ backgroundColor: element }}></div>
            </div>
          </li>
        ))}
      </ul>
      <div className="block-picker-container">
        <button className="white" onClick={props.handleClick2}>
          <Drop /> <span>Scegli</span>
        </button>
        {props.displayColorPicker2 ? (
          <div style={popover}>
            <div style={cover} onClick={props.handleClose2} />
            <SketchPicker
              key="sketch_picker_2"
              onChangeComplete={(color) => props.selectBrandColors(color.hex)}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

const Font = (props) => {
  const fonts = ["open-sans", "arial", "roboto"];
  return (
    <div className="font-box">
      <ul className="scroll list-components">
        {fonts.map((element, index) => (
          <li onClick={() => props.handleSelectVariant("font", element)}>
            <h4>Font {index + 1}</h4>
            <div>
              <div className="preview-font" style={{ fontFamily: element }}>
                <h5>{element}</h5>
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Tempore distinctio reiciendis enim quisquam provident velit
                  delectus eius sed iste!
                </p>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

const WithContainer = (props) => {
  return (
    <div className="select-variant-container" onClick={() => props.action()}>
      <h6>{props.label}</h6>
      <div className={`variant-container-container`}>
        <div className={`variant-container ${props.selected && "active"}`}>
          {props.content}
        </div>
      </div>
    </div>
  );
};
